<div class="row my-4" data-test-id="amp-api-key-container">
  <div class="col-12">
    <div class="label mb-1">{{ 'generate_amp_api_key_label' | translate }}</div>
    <div class="description mb-1">{{ 'generate_amp_api_key_description' | translate }}</div>
    <button
      ds-button
      [variant]="DsButtonVariants.microAction"
      [microActionIcon]="Icons.Gear"
      [disabled]="currentAmpApiKey$ | async"
      (click)="generateAmpApiKey()"
    >
      {{ 'generate_amp_api_key' | translate }}
    </button>

    @if (currentAmpApiKey$ | async; as ampApiKey) {
      <div class="mt-4 amp-api-key">
        <div class="label mb-1">{{ 'api_token_generated_key_label' | translate }}</div>
        <div class="description mb-1">{{ 'amp_api_key_description' | translate }}</div>
        <div class="amp-api-key-item">
          <div class="amp-api-key-details mb-2">
            <div class="label mb-1">{{ ampApiKey.name }}</div>
            <p class="mb-1">{{ 'amp_api_key_created' | translate: formatDate(ampApiKey.createdAt) }}</p>
            <p>{{ 'amp_api_key_expiry' | translate: formatDate(ampApiKey.expiry) }}</p>
          </div>
          <button
            class="float-end"
            ds-button
            [variant]="DsButtonVariants.microAction"
            [microActionIcon]="Icons.TrashCan"
            (click)="deleteAmpApiKey()"
          >
            {{ 'remove' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</div>
